import { RootState } from '@reducers';

export const selectCarQuotePage = (state: RootState) => state.carQuotePageReducer;
